import { render, staticRenderFns } from "./MiniCartDrawerItem.vue?vue&type=template&id=2931bcca&scoped=true&"
import script from "./MiniCartDrawerItem.vue?vue&type=script&lang=ts&"
export * from "./MiniCartDrawerItem.vue?vue&type=script&lang=ts&"
import style0 from "./MiniCartDrawerItem.vue?vue&type=style&index=0&id=2931bcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931bcca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default})
